module.exports = __webpack_public_path__ + "img/Piscis_austrinus.1e14cb5b.png";